export default {
  currency: {
    usd: 'Amerikan Doları',
    euro: 'Avro',
    try: 'Türk Lirası',
    addCurrency: 'Para Birimi Ekle',
  },
};
